function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 9.10019V12.1002H2.9L8.8 6.2002L5.8 3.2002L0 9.10019ZM7.2 6.2002L2.5 10.9002H1.2V9.5002L5.8 4.8002L7.2 6.2002Z",
  fill: "currentColor"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.0998 0L6.7998 2.3L9.79981 5.3L12.0998 2.9L9.0998 0ZM9.6998 3.6L8.4998 2.3L9.0998 1.7L10.3998 3L9.6998 3.6Z",
  fill: "currentColor"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.1998 8.5001H12.3998V6.7001C12.3998 6.4001 12.0998 6.1001 11.7998 6.1001C11.4998 6.1001 11.1998 6.4001 11.1998 6.7001V8.5001H9.3998C9.0998 8.5001 8.7998 8.8001 8.7998 9.1001C8.7998 9.4001 9.0998 9.7001 9.3998 9.7001H11.1998V11.5001C11.1998 11.8001 11.4998 12.1001 11.7998 12.1001C12.0998 12.1001 12.3998 11.8001 12.3998 11.5001V9.7001H14.1998C14.4998 9.7001 14.7998 9.4001 14.7998 9.1001C14.7998 8.8001 14.4998 8.5001 14.1998 8.5001Z",
  fill: "currentColor"
});
const SvgPencilPlusCurrentColor = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 13,
  viewBox: "0 0 15 13",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPencilPlusCurrentColor, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pencil-plus-currentColor.cb3b9622.svg";
export { ForwardRef as ReactComponent };